<div class="container">
  <!--Page title and search icon-->
  <div
    fxLayout="row">
    <div fxFlex="20%">
      <div class="form-page-name-search">
        Home
      </div>
    </div>
    <div fxFlex="80%">
      <div style="float: right">
        <div style="margin-top: 6px;">
          @if (formSearch) {
            <form [formGroup]="formSearch">
              <mat-form-field [hidden]="!displaySearchInput"
                class="form-page-name-search-input"
                floatLabel='never' >
                <input matInput #searchPhrase="matInput"
                  id="searchPhrase"
                  name="searchPhrase"
                  formControlName="searchPhrase"
                  placeholder="Search by name or address">
                </mat-form-field>
                <div style="display: inline-block" class="form-page-name-search-icon">
                  <button mat-icon-button type="submit"
                    matTooltip="Search by name or address"
                    [matTooltipPosition]="'above'"
                    (click)="onClickSearchIcon()">
                    <mat-icon color="primary">search</mat-icon>
                  </button>
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    </div>
    @if (visibleNotifications) {
      <div
        style="margin-top: 15px;">
        <mat-toolbar class="form-toolbar">
          <div class="form-action-title">
            Notifications
          </div>
        </mat-toolbar>
        <div >
          @for (notification of shownotifications; track notification) {
            <div>
              <app-notification
                [notification]="notification"
                (closeNotification)="handleClose($event)">
              </app-notification>
            </div>
          }
        </div>
      </div>
    }
    <!-- Page tool bar -->
    @if (!isContractor()) {
      <div style="margin-top: 15px;">
        <!--WAITLIST DWELLINGS -->
        <ebb-portal-dwelling-qualified-list
          [data]='currentDwellings'
          [currentUser]='currentUser'
          [textHomeownerDwellingQualified]='textHomeownerDwellingQualified' >
        </ebb-portal-dwelling-qualified-list>
      </div>
    }
    <!--Page tool bar-->
    @if (!isContractor()) {
      <div style="margin-top: 15px;">
        <mat-toolbar class="form-toolbar"
          fxShow.gt-sm fxHide.lt-md>
          <span class="form-action-title">
            APPLICATIONS IN PROGRESS
          </span>
          <span class="form-toolbar-spacer"></span>
          @if (!isInspector() && multipleAppsAllowed() === 2) {
            <a
              class="form-action-task"
              href="{{uriSpaRegistration}}">
              Register another property
            </a>
          }
          @if (isInspector()) {
            <div>
              <span class="form-toolbar-spacer"></span>
              <div class="form-action-task" style="display:inline">
                @if (toggleInspectedProjects) {
                  <a
                    class="form-action-task"
                    href="javascript:void(0)"
                    (click)="onClickToggleInspectedProjects()">
                    View Open Projects
                  </a>
                }
                @if (!toggleInspectedProjects) {
                  <a
                    class="form-action-task"
                    href="javascript:void(0)"
                    (click)="onClickToggleInspectedProjects()">
                    View Completed Projects
                  </a>
                }
              </div>
            </div>
          }
        </mat-toolbar>
        <div fxHide.gt-sm fxShow.lt-md>
          <div>
            <div class="form-action-title">APPLICATIONS IN PROGRESS</div>
            @if (!isInspector()) {
              <div style="display:inline;">
                <div class="form-action-task">
                  <a
                    class="form-action-task"
                    href="javascript:void(0)"
                    matTooltip="Actions"
                    [matTooltipPosition]="'below'"
                    [matMenuTriggerFor]="menu">
                    ACTIONS
                  </a>
                  <mat-menu #menu="matMenu">
                    @if (!isContractor() && multipleAppsAllowed() === 2) {
                      <button mat-menu-item
                        (click)='goToUrl(uriSpaRegistration)'>
                        <span>Register Another Property</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
            }
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    }

    @if (isContractor()) {
      <div
        style="margin-top: 15px;">
        <mat-toolbar class="form-toolbar" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutWrap>
          <!-- Project Title -->
          <div class="form-action-title" fxFlex="auto">
            Projects
          </div>
          <!-- Spacer for Flex Adjustment -->
          <span class="form-toolbar-spacer" fxFlex="1 1 auto"></span>
          <!-- Toggle Open/Closed Projects -->
          <div class="form-action-task" style="display:inline" fxFlex="auto">
            @if (toggleOpenClosedProjects) {
              <a
                class="form-action-task"
                href="javascript:void(0)"
                (click)="onClickToggleOpenClosedProjects()">
                View completed projects
              </a>
            }
            @if (!toggleOpenClosedProjects) {
              <a
                class="form-action-task"
                href="javascript:void(0)"
                (click)="onClickToggleOpenClosedProjects()">
                View open projects
              </a>
            }
          </div>
          <!-- View as Cards/List - Hide on Small Screens -->
          @if (isContractor()) {
            <div
              class="form-action-task"
              fxHide.lt-md
              style="margin-left: 15px;">
              <a href="javascript:void(0)"
                class="form-action-task"
                matTooltip="Click to change display"
                [matTooltipPosition]="'below'"
                [matMenuTriggerFor]="menuToggleDisplay">
                @if (toggleDisplayCardList) {
                  <span>
                    View as cards
                  </span>
                }
                @if (!toggleDisplayCardList) {
                  <span>
                    View as list
                  </span>
                }
                <mat-menu #menuToggleDisplay='matMenu'>
                  <button mat-menu-item (click)="toggleHomeDisplayMode(true)">
                    <mat-icon>view_module</mat-icon>
                    <span>View as cards</span>
                  </button>
                  <button mat-menu-item (click)="toggleHomeDisplayMode(false)">
                    <mat-icon>view_stream</mat-icon>
                    <span>View as list</span>
                  </button>
                </mat-menu>
              </a>
            </div>
          }
        </mat-toolbar>
      </div>
    }

  <!--User profile update-->
  @if (currentUser?.needsProfileUpdate) {
    <div
      style="margin-top: 18px;">
      <mat-card>
        <mat-card-title>
          Updating Your Profile
        </mat-card-title>
        <div style="margin-top:21px;">
          <div class="retrofit-form-text">
            <div [innerHTML]="textProfileNeedsUpdate"></div>
          </div>
        </div>
        <div style="margin-top: 12px;">
          <a mat-stroked-button color="primary" [routerLink]="['/account']">
            COMPLETE PROFILE
          </a>
        </div>
      </mat-card>
    </div>
  }
    <!-- NEW PROJECTS -->
    <ebb-portal-new-application-list
      [data]='newApplications'
      [ShowNewApplications]='ShowNewApplications()'
      [femareviewmessage]='femareviewmessage'
      [currentUser]='currentUser'
      [toggleDisplayCardList]='toggleDisplayCardList'
      (emitapplicationChangeEvent)="onEmitApplicationChangeEvent($event)">
    </ebb-portal-new-application-list>

    <!-- OPEN PROJECTS (and all inspectors open) -->
    <ebb-portal-open-application-list [data]='activeApplications' [ShowOpenApplications]='ShowOpenApplications()' [femareviewmessage]='femareviewmessage'
      [currentUser]='currentUser' [currentContact]='currentContact' [toggleDisplayCardList]='toggleDisplayCardList'
      [checkForOpenApplications]='checkForOpenApplications' [ShowOpenApplicationsMessage]='ShowOpenApplicationsMessage()'
      [toggleOpenClosedProjects]='toggleOpenClosedProjects'>
    </ebb-portal-open-application-list>

    <!-- CLOSED PROJECTS -->
    <ebb-portal-close-application-list
      [data]='closedApplications'
      [ShowClosedApplications]='ShowClosedApplications()'
      [currentUser]='currentUser'
      [toggleDisplayCardList]='toggleDisplayCardList'
      [checkForClosedApplications]='checkForClosedApplications'
      [ShowClosedApplicationsMessage]='ShowClosedApplicationsMessage()'
      [toggleOpenClosedProjects]='toggleOpenClosedProjects'>
    </ebb-portal-close-application-list>

    <!-- Completed applications-->
    <ebb-portal-completed-application-list [data]='completedApplications' [ShowCompletedApplications]='ShowCompletedApplications()'  [currentUser]='currentUser'
    [toggleDisplayCardList]='toggleDisplayCardList'></ebb-portal-completed-application-list>
    <div style="min-height: 50px;">
      @if (isHomeowner()) {
        <div>
          <!-- Withdrawn applications-->
          <ebb-portal-withdrawn-application-list [data]='getWithdrawn()' [ShowWithdrawnApplications]='ShowWithdrawnApplications()'  [currentUser]='currentUser'
          [toggleDisplayCardList]='toggleDisplayCardList' [dwellingwithdrawndata]="currentWithdrawnDwellings" ></ebb-portal-withdrawn-application-list></div>
        }
      </div>
      <div style="min-height: 50px;"></div>
    </div>
